
import { getRequest, postRequest } from '../tools/ajax.js'

// 投标申请
const TenderApply= params => postRequest('/api/pc/Tender/TenderApply', params);

// 投标记录查询
const Tender= params => postRequest('/api/pc/Tender/Tender', params);

// 投标记录编辑
const Edit= params => postRequest('/api/pc/Tender/TenderEdit', params);

// 用章申请录入
const SealApply = params => postRequest('/api/pc/Option/SealApply', params);
// 投标详情
const Detail= params => postRequest('/api/pc/Tender/Detail', params);

// 投标 撤销
const Upadte = params => postRequest('/api/pc/Tender/TenderUpdate', params);

// 投标 撤销
const allCheckTender = params => postRequest('/api/pc/Examine/AllCheckTender', params);


export {
    TenderApply,Tender,Detail,Edit,SealApply,Upadte,allCheckTender
}